import { render } from "./ResultsV2.vue?vue&type=template&id=630988b6&scoped=true"
import script from "./ResultsV2.vue?vue&type=script&lang=js"
export * from "./ResultsV2.vue?vue&type=script&lang=js"

import "./ResultsV2.vue?vue&type=style&index=0&id=630988b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630988b6"]])

export default __exports__